import { useSelector } from 'react-redux';

const useStore = () => {
  const addons = useSelector((state) => state.addons);
  const auth = useSelector((state) => state.auth);
  const booking = useSelector((state) => state.booking);
  const checkout = useSelector((state) => state.checkout);
  const event = useSelector((state) => state.event);
  const msci = useSelector((state) => state.msci);
  const payment = useSelector((state) => state.payment);
  const promotions = useSelector((state) => state.promotions);
  const security = useSelector((state) => state.security);
  const summary = useSelector((state) => state.summary);
  const surveys = useSelector((state) => state.surveys);
  const ticketsSelected = useSelector((state) => state.ticketsSelected);
  const ticketTypes = useSelector((state) => state.ticketTypes);
  const paths = useSelector((state) => state.paths);
  const customLinks = useSelector((state) => state.customLinks);
  const billboard = useSelector((state) => state.billboard);
  const exchange = useSelector((state) => state.exchange);

  const getStoreCopy = (message) => {
    const storeData = {
      addons,
      auth,
      booking,
      checkout,
      event,
      msci,
      payment,
      promotions,
      security,
      summary,
      surveys,
      ticketsSelected,
      ticketTypes,
      paths,
      customLinks,
      billboard,
      exchange,
    };

    if (message) {
      storeData.message = message;
    }

    return JSON.stringify(storeData);
  };
  return { getStoreCopy };
};

export default useStore;
